import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import CreateBrandMediumUploadSession from "./CreateBrandMediumUploadSession.graphql";

export default function useCreateBrandMediumUploadSession() {
    return useMutation(
        gql(CreateBrandMediumUploadSession)
    );
}
